import { createTheme } from "@mui/material/styles";
import type {} from "@mui/x-data-grid/themeAugmentation";

export const theme = createTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: "#418af4",
        },
        background: {
          default: "#f1f1f1",
        },
        DataGrid: {
          bg: "transparent",
          pinnedBg: "transparent",
          headerBg: "#fff",
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: "#418af4",
        },
        background: {
          default: "#000",
        },
        DataGrid: {
          bg: "transparent",
          pinnedBg: "transparent",
          headerBg: "#121212",
        },
      },
    },
  },

  typography: {
    fontFamily: [
      "Ubuntu",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: () => ({
        body: {
          "& .firebase-emulator-warning": {
            display: "none",
          },
        },
      }),
    },

    MuiInputBase: {
      defaultProps: {
        disableInjectingGlobalStyles: true,
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: ({ theme }) => ({
          borderColor: theme.palette.background.default,
        }),
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 150,
        },
        outlined: {
          border: "none",
          backgroundColor: "rgba(128, 128, 128, 0.12)",
          "&:hover": {
            border: "none",
            backgroundColor: "rgba(128, 128, 128, 0.2)",
          },
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.palette.background.default,
        }),
      },
    },

    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },

    MuiDataGrid: {
      styleOverrides: {
        root: ({ theme }) => ({
          "--DataGrid-rowBorderColor": theme.palette.background.default,
          "--DataGrid-containerTopBorderColor":
            theme.palette.background.default,
          "--DataGrid-containerBottomBorderColor":
            theme.palette.background.default,
        }),
        withBorderColor: ({ theme }) => ({
          borderColor: theme.palette.background.default,
        }),
      },
    },

    MuiChip: {
      styleOverrides: {
        filled: ({ theme }) =>
          theme.palette.mode === "dark"
            ? {
                "&.MuiChip-colorPrimary": {
                  backgroundColor: "rgba(65, 138, 244, 0.2)",
                  color: "rgba(130, 177, 255, 1)",
                },
                "&.MuiChip-colorSecondary": {
                  backgroundColor: "rgba(186, 104, 200, 0.2)",
                  color: "rgba(206, 147, 216, 1)",
                },
                "&.MuiChip-colorSuccess": {
                  backgroundColor: "rgba(102, 187, 106, 0.2)",
                  color: "rgba(129, 199, 132, 1)",
                },
                "&.MuiChip-colorError": {
                  backgroundColor: "rgba(244, 67, 54, 0.2)",
                  color: "rgba(239, 154, 154, 1)",
                },
                "&.MuiChip-colorWarning": {
                  backgroundColor: "rgba(255, 167, 38, 0.2)",
                  color: "rgba(255, 183, 77, 1)",
                },
                "&.MuiChip-colorInfo": {
                  backgroundColor: "rgba(41, 182, 246, 0.2)",
                  color: "rgba(79, 195, 247, 1)",
                },
                "&.MuiChip-colorDefault": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  color: "rgba(255, 255, 255, 0.7)",
                },
              }
            : {},
      },
    },
  },
});
